/**
 *@author shaolei
 *@date 2020/08/24
 *@file_name:testApi
 *@Description: 接口调试
 */
<template>
  <div class="testApi">
    <div class="title">
      <div class="_p">接口调试</div>
    </div>
    <div class="section clearfix">
      <div class="left">
        <div class="api_title">
          <img src="@/assets/images/api_logo.png" alt="">接口调试
        </div>
        <div class="request">
          <div class="list">
            <div class="item">
              <div class="label">选择接口</div>
              <div class="value">
                <el-select v-model="value" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="item">
              <div class="label">app-key</div>
              <div class="value">
                <el-input readonly v-model="appKey" placeholder="xxxx(readonly)"></el-input>
              </div>
            </div>
            <div class="item">
              <div class="label">sign签名</div>
              <div class="value">
                <el-input readonly v-model="sign" placeholder=""></el-input>
              </div>
            </div>
            <div class="item">
              <div class="label">请求参数</div>
              <div class="value">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6}"
                  placeholder="输入请求参数"
                  v-model="params">
                </el-input>
              </div>
            </div>
            <div class="item">
              <div class="label">返回数据</div>
              <div class="value">
                <el-input
                  type="textarea"
                  readonly
                  :autosize="{ minRows: 6, maxRows: 6}"
                  placeholder=""
                  v-model="params">
                </el-input>
              </div>
            </div>
            <div class="item">
              <div class="label"></div>
              <div class="value">
                <el-button type="primary">发送请求</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="api_title">
          <img src="@/assets/images/api_logo.png" alt="">请求示例
        </div>
        <div class="request_text"></div>
        <div class="api_title">
          <img src="@/assets/images/response.png" alt="">返回示例
        </div>
        <div class="response_text"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "testApi",
  data() {
    return {
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: "",
      appKey: "",
      sign: "",
      params: ""
    };
  },

  components: {
    //组件声明
  },

  computed: {
    //计算属性
  },

  created() {
    //创建时执行
  },

  mounted() {
    //数据挂载
  },

  methods: {
    //函数声明
  }
};
</script>

<style lang='less' scoped>
.testApi {
  margin-bottom: 20px;

  .title {
    position: relative;
    height: 64px;
    display: flex;
    align-items: center;
    .apply {
      position: absolute;
      -moz-user-select: none;
      /*火狐*/
      -webkit-user-select: none;
      /*webkit浏览器*/
      -ms-user-select: none;
      /*IE10*/
      -khtml-user-select: none;
      /*早期浏览器*/
      user-select: none;
      cursor: pointer;
      padding: 5px 22px;
      font-size: 14px;
      color: #333333;
      border-radius: 2px;
      right: 0;
      background: #fabe00;
    }
    &::after {
      content: "";
      position: absolute;
      height: 1px;
      left: 0px;
      right: 0px;
      bottom: 0;
      background: #ebebec;
    }
    ._p {
      font-size: 16px;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        width: 4px;
        left: -20px;
        top: 5px;
        bottom: 5px;
        background: #fabe00;
      }
    }
  }
  .section {
    margin-top: 30px;

    > div {
      float: left;
      min-height: 546px;
      background: #f7f7f7;
      border-radius: 2px;
      padding: 20px 30px;
      box-sizing: border-box;
    }
    .api_title {
      font-size: 18px;
      color: #272727;
      line-height: 32px;
      padding: 12px 0;
      border-bottom: 1px solid #e4dfdf;

      img {
        width: 32px;
        height: 32px;
        vertical-align: middle;
        margin-right: 12px;
      }
    }
    .list{
      padding-top: 16px;

      .item{
        display: flex;
        padding: 6px 14px;

        .label{
          text-align: right;
          width: 80px;
          padding-right: 8px;
          font-size: 14px;
          padding-top: 8px;
        }

        .value{
          width: 100%;

          .el-select{
            display: block;
          }

          .el-button{
            width: 100%;
          }
        }
        
      }
    }
    .left {
      width: 450px;
    }
    .right {
      width: calc(100% - 470px);
      margin-left: 20px;

      .request_text,.response_text{
        min-height: 232px;
      }
    }
  }
}
</style>